module.exports = __webpack_public_path__ + "static/media/international-competition-1.1.d1681afb.jpg";